export class InternalServerError extends Error {
  constructor() {
    super("An unexpected error occurred.");
  }
}

export class NotFoundError extends Error {
  constructor() {
    super("The requested resource was not found.");
  }
}

export class BadRequestError extends Error {
  constructor() {
    super("The request was invalid.");
  }
}

export class TooManyRequestsError extends Error {
  constructor() {
    super("Too many requests. Please try again later.");
  }
}
